import { LoadingButton } from '@/components/ui/loading-button'
import { ChevronRight } from 'lucide-react'

type FixedTabProps = {
  onClick: () => void
  loading: boolean
  disabled: boolean
  text: string
  upperText: string
}

export const FixedBottomButton: React.FC<FixedTabProps> = ({
  onClick,
  loading,
  disabled,
  text,
  upperText,
}) => {
  return (
    <div
      className="fixed bottom-0 left-0 text-center w-full bg-white px-4 py-2 md:hidden"
      style={{
        zIndex: 30,
        boxShadow:
          '0 -4px 6px -1px rgba(0, 0, 0, 0.1), 0 -2px 4px -1px rgba(0, 0, 0, 0.06)',
      }}
    >
      {upperText.trimEnd() != '選択中の商品:' && (
        <div className="py-2 text-[#333] border-b border-gray-200 text-left mb-2 font-semibold text-sm">
          {upperText}
        </div>
      )}
      <LoadingButton
        loading={loading}
        className={
          'main-loading-button button-color main-color w-full text-base rounded-lg text-center relative font-semibold p-5 h-[50px] text-white'
        }
        disabled={disabled}
        onClick={onClick}
      >
        {text}
        <span
          className="absolute font-bold text-2xl"
          style={{ color: '#fff', top: '15px', right: '12px' }}
        >
          <ChevronRight strokeWidth={'3px'} width={20} height={20} />
        </span>
      </LoadingButton>
    </div>
  )
}
